const scope = {
    name_exists: '此作用域名称 {{name}} 已被使用',
    name_with_space: '作用域名称不能包含任何空格。',
};
export default Object.freeze(scope);
